module.exports = __webpack_public_path__ + "static/media/Shopify.cb9bf0cf.png";